import * as React from 'react'
import { SVGProps } from 'react'
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height={335.765}
    viewBox="0 0 335.765 335.765"
    width={335.765}
    {...props}
  >
    <path d="M311.757 41.803 107.573 245.96l-83.587-83.596L0 186.393l107.573 107.569L335.765 65.795z" />
  </svg>
)
export default SvgCheck
